export default __webpack_public_path__ + "static/media/me.e1e404d0.png";